// extracted by mini-css-extract-plugin
export var actionButton = "_8n-1";
export var actionButtons = "_8n-2";
export var actions = "_8n-0";
export var aiUnread = "_8n-10";
export var alignCenter = "_8n-h";
export var backWrapper = "_8n-3";
export var cellContainer = "_8n-4";
export var checkboxContainer = "_8n-5";
export var contentContainer = "_8n-6";
export var contentHeader = "_8n-8";
export var conversationsTableWrapper = "_8n-s";
export var draftReplyBadgeContainer = "_8n-m";
export var dropdownItem = "_8n-b";
export var dropdownItemsContainer = "_8n-a";
export var dropdownTitle = "_8n-c";
export var errorIcon = "_8n-7";
export var filter = "_8n-d";
export var gray = "_8n-i";
export var headerActionButtons = "_8n-e";
export var headerCheckboxContainer = "_8n-f";
export var icon = "_8n-j";
export var menuContainer = "_8n-k";
export var noMoreTicketsIcon = "_8n-12";
export var noMoreTicketsSubText = "_8n-13";
export var oneLine = "_8n-l";
export var optionsButton = "_8n-n";
export var plus = "_8n-o";
export var portalButtonsWrapper = "_8n-g";
export var red = "_8n-p";
export var scrolledTop = "_8n-9";
export var search = "_8n-q";
export var selectedConversationsCount = "_8n-r";
export var spinner = "_8n-t";
export var strong = "_8n-u";
export var summaryCell = "_8n-v";
export var tableContainer = "_8n-11";
export var tagContainer = "_8n-w";
export var threeDots = "_8n-x";
export var twoLines = "_8n-y";
export var unread = "_8n-z";